import {useMemo, useState, useCallback} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {JobCustomHeaderColumn} from './columns/JobCustomHeaderColumn'
import {JobCustomRow} from './columns/JobCustomRow'
import {
  useQueryResponseData,
  useQueryResponseLoading,
} from '../core/QueryResponseProvider'
import {jobsColumns} from './columns/_columns'
import {Job} from '../core/_models'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {JobListSearchComponent} from '../components/JobListSearchComponent'
import JobAdd from './columns/JobAdd'
import {UsersListLoading} from '../../users-list/components/loading/UserListLoading'
import { JobListPagination } from '../components/pagination/JobListPagination'
import ApplicantsModal from '../components/ApplicantsModal'

const JobTable = () => {
  const jobs = useQueryResponseData()
  const isLoading = useQueryResponseLoading()

  const [showApplicantsModal, setShowApplicantsModal] = useState(false)
  const [selectedJob, setSelectedJob] = useState<{ id: string; title: string } | null>(null)

  const handleOpenApplicantsModal = useCallback((jobId: string, jobTitle: string) => {
    setSelectedJob({ id: jobId, title: jobTitle })
    setShowApplicantsModal(true)
  }, [])

  const handleCloseApplicantsModal = useCallback(() => {
    setShowApplicantsModal(false)
    setSelectedJob(null)
  }, [])

  const data = useMemo(() => jobs, [jobs])
  const columns = useMemo(() => jobsColumns(handleOpenApplicantsModal), [handleOpenApplicantsModal])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='pt-8 pb-4'>
      <div className='mb-7 mt-0 d-flex align-items-center'>
        <div>
          <JobListSearchComponent placeholder='Search Jobs' />
        </div>
        <div className='ms-auto'>
          <JobAdd />
        </div>
      </div>
      <div className='table-responsive'>
        <table
          id='kt_table_jobs'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-gray-800 fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Job>) => (
                <JobCustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Job>, i) => {
                prepareRow(row)
                return <JobCustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={10}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <JobListPagination />
      {isLoading && <UsersListLoading />}
      {selectedJob && (
        <ApplicantsModal
          jobId={selectedJob.id}
          jobTitle={selectedJob.title}
          isOpen={showApplicantsModal}
          onClose={handleCloseApplicantsModal}
        />
      )}
    </KTCardBody>
  )
}

export {JobTable}
